import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "../../utils/StaticFunctions";
import Api from "../../utils/Api";
import Select from "react-select";
import InputField from "../../utils/InputField";

class DataCollectorAddContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            datacollectorIds: [],
            companies: [],
            locations: [],
            currentCompanyId: null,
            currentLocationId: null,
            inputError: [],
            inputParams: {
                datacollectorId: '',
            }
        };

        this.translate = this.props.baseData.translate;

        this.requestCompaniesForUser = this.requestCompaniesForUser.bind(this);
        this.validateDataCollectorId = this.validateDataCollectorId.bind(this);
        this.setInputError = this.setInputError.bind(this);
        this.getInput = this.getInput.bind(this);
        this.selectCompany = this.selectCompany.bind(this);
        this.selectLocation = this.selectLocation.bind(this);

    }

    componentWillMount() {

        this.requestCompaniesForUser();
        this.requestDataCollectorIds();

        if (this.props.datacollector) {
            this.setState({
                currentCompanyId: this.props.datacollector.id_company,
                currentLocationId: this.props.datacollector.id_location,
                inputParams: this.props.datacollector
            });
        }

    }

    requestCompaniesForUser() {

        const params = {
            action: 'getCompaniesForUser',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    companies: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }
/*
    requestCompaniesForUser() {

        if (this.props.baseData.checkUserRole('superadmin')) {
            const opts = StaticFunctions.getSelectOptionsFromArray(this.props.baseData.companies.companies);
            const locations = StaticFunctions.getSelectOptionsFromArray(this.getLocationsByCompanyId(this.state.currentCompanyId));

            this.setState({
                locations: locations,
                companies: opts
            });
        }

    }
*/
    requestDataCollectorIds() {

        if (this.props.baseData.checkUserRole('superadmin')) {
            const params = {
                action: 'getDataCollectorIds',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                userId: this.props.baseData.userData.id
            };

            const callback = function (res) {
                if (res) {
                    this.setState({
                        datacollectorIds: res
                    });
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    enterSaveEditDataCollector(event) {

        if (event.keyCode === 13) {
            this.saveNewDataCollector();
        } else if (event.keyCode === 27) {
            this.props.changeView();
        }

    }

    saveNewDataCollector() {

        const datacollectorId = this.state.inputParams.datacollectorId;
        const currentCompanyId = this.state.currentCompanyId;
        const currentLocationId = this.state.currentLocationId;

        if (datacollectorId && currentCompanyId) {
            this.resetInputError();

            const params = {
                action: 'addDataCollector',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                id: datacollectorId,
                companyId: currentCompanyId,
                locationId: currentLocationId,
            };

            const callback = function (res) {
                if (res) {
                    alert(this.translate(res.msgKey));

                    if (res.success) this.props.changeView();
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        } else {
            const inputError = [];
            if (!datacollectorId) inputError.push('datacollectorId');
            if (!currentCompanyId) inputError.push('company');

            this.setInputError(inputError);
        }

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    validateDataCollectorId(datacollectorId) {

        const datacollectorIds = this.state.datacollectorIds;

        if (!datacollectorId || datacollectorIds.length === 0) return false;

        return !(datacollectorIds.some((id) => {return id === datacollectorId}));

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    selectCompany(event) {

        const currentCompanyId = ((event && event.value)) ? event.value : null;
        const locations = StaticFunctions.getSelectOptionsFromArray(this.getLocationsByCompanyId(currentCompanyId));

        this.setState({
            locations: locations,
            currentCompanyId: currentCompanyId,
            currentLocationId: null
        });

    }

    selectLocation(event) {

        const currentLocationId = ((event && event.value)) ? event.value : null;

        this.setState({
            currentLocationId
        });

    }

    getLocationsByCompanyId(id) {

        if (!id) return [];

        const locations = this.props.baseData.locations;

        return locations.filter((location) => String(location.id_company) === String(id));

    }

    render() {

        if (!this.props.baseData.checkUserRole('superadmin')) return null;

        const datacollectorId = (this.state.datacollectorId) ? this.state.datacollectorId : '';
        const currentCompanyId = (this.state.currentCompanyId) ? this.state.currentCompanyId : '';
        const currentLocationId = (this.state.currentLocationId) ? this.state.currentLocationId : '';

        const companies = StaticFunctions.getSortedData(this.state.companies, 'label', 'string');
        const locations = StaticFunctions.getSortedData(this.state.locations, 'label', 'string');

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('createNewDataCollector')} ({this.translate('superadminOnly')})</h1>
                </nav>

                <div className="col-xs-12 col-lg-4">
                    <div className="formRow">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-left labelSpan">{this.translate('id')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="datacollectorId"
                                            className={this.checkInputError('datacollectorId')}
                                            isRequired={true}
                                            value={datacollectorId}
                                            validate={this.validateDataCollectorId}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('company')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="company"
                                            className={"chosen-container chosen-container-single " + this.checkInputError('company')}
                                            style={{width: '260px'}}
                                            options={companies}
                                            onChange={this.selectCompany}
                                            isRequired={true}
                                            value={companies.find(o => String(o.value) === String(currentCompanyId)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={true}
                                            noResultsText={this.translate('noResultsFound')}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('location')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="location"
                                            className="chosen-container chosen-container-single"
                                            style={{width: '260px'}}
                                            options={locations}
                                            onChange={this.selectLocation}
                                            value={locations.find(o => String(o.value) === String(currentLocationId)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={true}
                                            noResultsText={this.translate('noResultsFound')}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan webElement">&nbsp;</td>

                                    <td className="text-left">
                                        <a className="formButton" onClick={() => this.props.changeView()}>
                                            {this.translate('cancel')}
                                        </a>

                                        <a className="formButton" onClick={() => this.saveNewDataCollector()} onKeyDown={(event) => this.enterSaveEditDataCollector(event)}>
                                            {this.translate('save')}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

}

export default DataCollectorAddContainer;